// extracted by mini-css-extract-plugin
export default {"nav":"Navbar_nav__p5Fw3","brand":"Navbar_brand__LLUxu","logo":"Navbar_logo__n-yLZ","name":"Navbar_name__YgLnD","cta":"Navbar_cta__f959p","logoImg":"Navbar_logoImg__8Re38"};